export default class VodCookieGenerator{
    static setVodaCookie(name, value) {
        const domainvalue = process.env.REACT_APP_BASE_URL.replace('https://', '');
        const vodacomCookie = `${name}=${value};path=/;domain=${domainvalue}`;
        document.cookie = vodacomCookie;
    }
}


